export default "__VITE_ASSET__Dhl6A5mT__"